import React from 'react';
import { motion } from 'framer-motion';
import { LuLightbulb } from 'react-icons/lu';

const TestimonialCard = ({ testimonial, index }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="bg-slate-900/50 backdrop-blur p-8 md:p-10 border border-white/10 rounded-2xl relative group hover:border-brand-cyan transition-colors"
    >
      <LuLightbulb className="w-12 h-12 text-white/5 absolute top-6 left-6 -z-0 group-hover:text-brand-cyan/10 transition-colors" />
      
      <div className="relative z-10">
        <p className="text-lg text-slate-300 font-medium leading-relaxed mb-8">
          "{testimonial.quote}"
        </p>
        <div className="flex items-center gap-4">
          <img src={testimonial.image} alt={testimonial.author} className="shrink-0 w-12 h-12 rounded-full object-cover border-2 border-brand-cyan" />
          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest text-white">{testimonial.author}</h4>
            <p className="text-xs text-brand-yellow font-bold">{testimonial.position}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TestimonialCard;